module.exports = __webpack_public_path__ + "img/calendar.b03c6890.svg";